module.exports = __webpack_public_path__ + "img/45.4ea82aa6.png";